import React, { useMemo } from "react";
import useSWR from "swr";
import HeroSection from "../../Components/Common/HeroSection";
import Contact from "../Home/Components/Contact";
import { motion } from "framer-motion";
import { StaticPageApiUrls } from "../../Api/Auth/ApiUrls";
import { noAuthfetcher } from "../../Api/swrConfig";
import { Loader } from "../../Components/Common/Loader";

const DEFAULT_BACKGROUND =
  "https://storage.googleapis.com/road-to-fe/uploads/1741417535659-07d447cd-82a2-4b1b-8c08-9fffeaaefa18-colleagues-doing-team-work-project_23-2149361607.avif";
const DEFAULT_IMAGE =
  "https://storage.googleapis.com/road-to-fe/uploads/1741110100881-3352082b-c129-4963-b7ec-31bb27177882-tutorial.webp";
const DEFAULT_DESCRIPTION =
  "Road to FE is built by engineers and educators who are obsessed with leveling up the PE exam prep experience. We combine deep subject expertise, thoughtful instructional design, and real-world accountability to help you succeed.";

const AboutUs = () => {
  const slug = "about-us";

  const { data, isLoading } = useSWR(
    StaticPageApiUrls.info(slug),
    noAuthfetcher
  );

  const parsedContent = useMemo(() => {
    try {
      return data?.data?.content
        ? JSON.parse(data.data.content)
        : {};
    } catch (error) {
      console.warn("Failed to parse About Us content", error);
      return {};
    }
  }, [data]);

  const title = data?.data?.title || "About Us";
  const subtitle =
    data?.data?.headerDescription ||
    parsedContent?.subtitle ||
    "One Platform Many Options To Explore";
  const backgroundImage =
    parsedContent?.backgroundImage || DEFAULT_BACKGROUND;
  const featureImage = data?.data?.image || parsedContent?.image || DEFAULT_IMAGE;
  const bodyHtml =
    parsedContent?.content ||
    data?.data?.bodyDescription ||
    `<p>${DEFAULT_DESCRIPTION}</p>`;

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader />
      </div>
    );
  }

  return (
    <motion.div
      initial={{ opacity: 1, y: -40 }} // Start above the view
      whileInView={{ opacity: 1, y: 0 }} // End at normal position
      transition={{ duration: 1, ease: "easeOut" }} // Longer transition for more emphasis
    >
      <HeroSection
        title={title}
        backgroundImage={backgroundImage}
        subtitle={subtitle}
      />
      <div className="gap-3 container mx-auto sm:mt-12 mt-4 flex justify-center md:justify-between items-start flex-wrap md:flex-nowrap px-2">
        <div
          className="max-w-5xl w-full prose prose-primary"
          dangerouslySetInnerHTML={{ __html: bodyHtml }}
        />
        <div>
          <img
            src={featureImage}
            alt={title}
            className="w-full h-72 object-cover rounded-md"
          />
        </div>
      </div>
      <Contact />
    </motion.div>
  );
};

export default AboutUs;
